import React from 'react';
import {setGetUsers} from '../../../users/store/thunk/setGetUsers';
import {setGetBonusesHistory} from '../../store/thunk/setGetBonusesHistory';
import {useDispatch} from 'react-redux';
import {useStyles} from './helpers';
import Title from '../../../../../@casino/ui/title';
import clsx from 'clsx';

const Tabs = ({setActiveTab, effect, setSearch, activeTab, search}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    return (
        <>
            <Title label="Выдача персонального бонуса" />
            <div className={clsx(classes.mb12, classes.rootPersonalBonus)}>
                <div className={classes.root}>
                    <div className={classes.wrap}>
                        <span 
                            style={{
                                color: activeTab === 'gamer' ? '#00a3f9' : '#acb5d6',
                                borderBottom: activeTab === 'gamer' ? '2px solid #00a3f9' : false,
                            }}
                            className={classes.tab}
                            onClick={() => {
                                setActiveTab('gamer'); 
                                setSearch('')
                            }}
                        >
                            Игроки
                        </span>
                        <span 
                            style={{
                                color: activeTab === 'history' ? '#00a3f9' : '#acb5d6',
                                borderBottom: activeTab === 'history' ? '2px solid #00a3f9' : false,
                            }}
                            className={classes.tab}
                            onClick={() => {
                                setActiveTab('history'); 
                                setSearch('');
                            }}
                        >
                            История
                        </span>
                    </div>
                    <input 
                        type="text"
                        placeholder="Поиск игроков"
                        className={classes.search}
                        value={search}
                        onChange={(v) => {
                            if (activeTab === 'gamer') {
                                dispatch(setGetUsers({
                                    search: v.target.value,
                                    page: 1,
                                    rowsPerPage: 10,
                                    order: 'id',
                                    desc: false
                                }))
                            } else if (activeTab === 'history') {
                                dispatch(setGetBonusesHistory({
                                    bonus_label: 'bonus-personal',
                                    page: 1,
                                    rowsPerPage: 10,
                                    order: 'id',
                                    desc: false,
                                    search: v.target.value
                                }))
                            }            
                            setSearch(v.target.value);
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default Tabs;